import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ManualJournalRecurringUpdate } from "@common/types/domains/accounting/manualJournalRecurringRule";
import { AccountingLedgerBasis } from "@common/types/domains/accounting/ledger";
import { accountingReportsQueryKeys } from "@api/accountingReports.api";
import { deleteJournalEntry } from "@lib/accounting";
import { useToaster } from "@design-system/ToastMessages/useToaster";

interface UseDeleteJournalEntryParams {
    journalEntryId: string | undefined;
    entityId: number;
    onSuccess: () => void;
}

interface MutationParams {
    ledgerBasis: AccountingLedgerBasis;
    ledgerId?: string;
    recurringRuleUpdateType?: ManualJournalRecurringUpdate;
}
export function useDeleteJournalEntry({
    journalEntryId,
    entityId,
    onSuccess,
}: UseDeleteJournalEntryParams) {
    const queryClient = useQueryClient();
    const { toast } = useToaster();

    return useMutation({
        mutationFn: async ({
            ledgerBasis,
            ledgerId,
            recurringRuleUpdateType,
        }: MutationParams) => {
            if (!journalEntryId) {
                return;
            }

            await deleteJournalEntry({
                entityId,
                journalEntryId,
                recurringRuleUpdateType,
                ledgerBasis,
                ledgerId,
            });

            queryClient.invalidateQueries({
                queryKey: [accountingReportsQueryKeys.accountTransactions],
            });

            toast(`Journal entry deleted`);

            onSuccess();
        },
    });
}
